import React, { useState } from 'react';
import parse from 'html-react-parser';

type Props = {
    text: string;
    audioOpened: boolean;
    setAudioOpened: (a: boolean) => void;
    audio: any;
};

export default function ZdarTaskTitle({ text, audioOpened, setAudioOpened, audio }: Props) {
    const [dragging, setDragging] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        if (!dragging) {
            setAudioOpened(true);
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!dragging) {
            setAudioOpened(true);
        }
        setDragging(false);
    };

    return (
        <React.Fragment>
            <div className="task-title">
                {audio && !audioOpened && (
                    <div className="task-title-audio-icon">
                        <img
                            src="/common/audio-play.gif"
                            alt="play"
                            onTouchStart={() => {
                                setDragging(false);
                            }}
                            onTouchMove={() => {
                                setDragging(true);
                            }}
                            onTouchEnd={handleTouch}
                            onClick={handleClick}
                            width={34}
                        />
                    </div>
                )}
                <div className="task-title-text">{parse(text)}</div>
                {audio && !audioOpened && (
                    <div className="task-title-audio-icon">
                        <div className="task-title-placeholder" />
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}
